import moment from "moment-timezone";

export function jsday_to_daystr(jsday) {
  switch (jsday) {
    case 0:
      return "Sun";
    case 1:
      return "Mon";
    case 2:
      return "Tue";
    case 3:
      return "Wed";
    case 4:
      return "Thu";
    case 5:
      return "Fri";
    case 6:
      return "Sat";
    default:
      throw new Error(`invalid day: ${jsday}`);
  }
}

export function dayStrAsLocalDate(dateStr) {
  const d = new Date(dateStr);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

export function date_with_time(date, time_str, timezone): Date {
  // sanity check
  if (date.getHours() !== 0 && date.getMinutes() !== 0)
    throw new Error(`Date must be on the start of the day: ${date}`);
  const [hours, minutes] = time_str.split(":").slice(0, 2);
  const d = moment.tz(
    {
      year: date.getFullYear(),
      month: date.getMonth(),
      days: date.getDate(),
      hour: parseInt(hours),
      minutes: parseInt(minutes),
    },
    timezone,
  );
  return new Date(d.valueOf());
}

export function datetime_interval_intersection(
  a,
  b,
): null | Record<string, string> {
  if (!datetime_interval_intersect(a, b)) return null;
  return {
    start: a.start > b.start ? a.start : b.start,
    end: a.end < b.end ? a.end : b.end,
  };
}

export function datetime_interval_intersect(a, b) {
  return a.start <= b.end && b.start < a.end;
}

export function datetime_interval_intersect_any(interval, any_other_interval) {
  if (!any_other_interval) return false;
  return any_other_interval.some((rhs) =>
    datetime_interval_intersect(interval, rhs),
  );
}

export const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;

export function time_format_hour_minutes(time) {
  if (!time) return time;
  const t = time.split(":");
  return `${(t[0] || 0).toString().padStart(2, "0")}:${(t[1] || 0)
    .toString()
    .padStart(2, "0")}`;
}

export function time_format_hour_minutes_seconds(time) {
  if (!time) return time;
  const t = time.split(":");
  return `${(t[0] || 0).toString().padStart(2, "0")}:${(t[1] || 0)
    .toString()
    .padStart(2, "0")}:${(t[2] || 0).toString().padStart(2, "0")}`;
}

export function is_valid_time_interval(interval) {
  return (
    time_format_hour_minutes_seconds(interval.start_time) <=
    time_format_hour_minutes_seconds(interval.end_time)
  );
}

export function assert_valid_time_interval(interval) {
  if (!is_valid_time_interval(interval))
    throw new Error("end of the time interval must be greater than start");
}

export function is_valid_datetime_interval(interval) {
  return interval.start <= interval.end;
}

export function assert_valid_datetime_interval(interval) {
  if (!is_valid_datetime_interval(interval))
    throw new Error("end of the time interval must be greater than start");
}
